import { BodyOf } from "../../../core/api";

export type IncidentSubtype = NonNullable<
  BodyOf<"post", "./visit_daily_notes/approve">["determinations"][number]["incidentSubtype"]
>;

/**
 * The subtypes Salesforce accepts on a critical incident, spelled the way Salesforce
 * spells them.
 *
 * Unlike a disposition there is no separate label: the value is what the Case is opened
 * as, and the reviewer should see the same words Salesforce will. The server owns the
 * list and refuses anything outside it, so this is only the choices on screen; it is
 * alphabetical because there is no natural order to the kinds of incident, and because
 * the classifier's suggestion is pre-selected, so the reviewer rarely has to scan it.
 *
 * `Other` always goes to a person on Salesforce's side.
 */
export const INCIDENT_SUBTYPES: readonly IncidentSubtype[] = [
  "Abuse",
  "Criminal Activity / Theft",
  "Death other than natural cause",
  "Exploitation",
  "Fraud / Waste / Abuse",
  "Legal Involvement",
  "Medication Errors",
  "Missing Person / Loss of Contact / Elopement",
  "Neglect",
  "Other",
  "Provider and Staff member misconduct",
  "Safeguarding Intervention",
  "Serious injury",
  "Service Interruption",
  "Suicide Threat / Suicide Attempt",
  "Unplanned Hospitalization",
  "Unsafe Living Environment",
];
